import type { IntegrationProvider, ReportErrorOptions } from "./types";

export type ReportErrorFn = (options: ReportErrorOptions) => string;

export type RunIntegrationActionOptions = {
  provider: IntegrationProvider;
  fallback: string;
  report: ReportErrorFn;
  surface?: ReportErrorOptions["surface"];
};

export type IntegrationActionResult<T> =
  | { ok: true; data: T }
  | { ok: false; message: string };

export async function runIntegrationAction<T>(
  fn: () => Promise<T>,
  options: RunIntegrationActionOptions
): Promise<IntegrationActionResult<T>> {
  try {
    const data = await fn();
    return { ok: true, data };
  } catch (error) {
    const message = options.report({
      error,
      provider: options.provider,
      fallback: options.fallback,
      surface: options.surface ?? "toast",
    });
    return { ok: false, message };
  }
}
